import convert from 'convert';
import { REGION, RegionEnum } from 'gatsby-theme-hem-store/src/constants';
import round from 'lodash/round';
import toNumber from 'lodash/toNumber';

export function valueAsMetricOrImperial(
  key: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any,
): string {
  switch (key) {
    case 'dimmable':
      return value ? 'Yes' : 'No';
    case 'height':
    case 'seatHeight':
    case 'backrestHeight':
      return value + (REGION === RegionEnum.Us ? ' in' : ' cm');
    case 'length':
    case 'width':
    case 'depth':
    case 'seatWidth':
    case 'seatDepth':
    case 'armrestHeight':
    case 'packageWidth':
    case 'packageHeight':
    case 'packageLength':
    case 'cableLength':
    case 'diameter':
    case 'pileHeight':
    case 'shelfDepth':
    case 'shelfWidth':
      return REGION === RegionEnum.Us
        ? round(convert(toNumber(value), 'cm').to('in'), 1) + ' in'
        : round(toNumber(value), 1) + ' cm';
    case 'weight':
    case 'grossWeight':
      return REGION === RegionEnum.Us
        ? round(convert(toNumber(value), 'kg').to('pounds'), 1) + ' lbs'
        : round(toNumber(value), 1) + ' kg';
    case 'packageVolume':
      return round(toNumber(value), 3) + ' m³';
    case 'capacity':
      return REGION === RegionEnum.Us
        ? round(convert(toNumber(value), 'ml').to('oz. fl.'), 1) + ' oz'
        : round(toNumber(value), 1) + ' ml';
    case 'stackability': {
      const [qty, height] = `${value}`.split('|');
      return REGION === RegionEnum.Us
        ? `${qty} pcs. (${round(
            convert(toNumber(height), 'cm').to('in'),
            1,
          )} in)`
        : `${qty} pcs. (${round(toNumber(height), 1)} cm)`;
    }
    default:
      return value;
  }
}
